/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import TagModel from 'cio/models/tag';
import CampaignModel from 'cio/models/campaign';
import { ALL_CHANNELS, Grouping, Measure } from 'cio/utils/metrics/common';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import { ActionType } from 'cio/models/action';
import { actionTypeName } from 'cio/utils/action-info';
import { SortDirection } from 'cio/utils/sort';
import { CAMPAIGN_METRIC_SORT_OPTIONS } from 'cio/utils/campaigns/sort-options';
import { TimeRange } from 'cio/utils/time';

interface CampaignsTableSignature {
  Args: {
    resolution: Grouping;
    range: TimeRange;
    isLoading: boolean;
    sortBy: string;
    sortDirection: SortDirection;
    measures: Measure[];
    campaigns: CampaignModel[];
    onSort: (sortBy: string, direction: string) => unknown;
    onTagClicked: (tag: TagModel) => unknown;
    afterArchiveCampaignAction: (campaign: CampaignModel) => unknown;
    afterDeleteCampaignAction: (campaign: CampaignModel) => unknown;
    afterUnarchiveCampaignAction: (campaign: CampaignModel) => unknown;
  };
  Element: HTMLTableElement;
}

export default class CampaignsTable extends Component<CampaignsTableSignature> {
  @service environment!: EnvironmentService;

  defaultSortDirection = SortDirection.Descending;

  get measures() {
    return this.args.measures.map((measure) => {
      return CAMPAIGN_METRIC_SORT_OPTIONS.find((m) => m.value === measure);
    });
  }

  get enabledChannels() {
    return [...ALL_CHANNELS]
      .map((channel) => `${channel}_action`)
      .filter((type: ActionType) => this.environment.enabledAction(type))
      .map((type: ActionType) => actionTypeName(type));
  }
}
